/*
 * MarkerGroups is in charge of generating groups of markers
 * based on the data from self.options.markersData. This plugin
 * will make the groups available at:
 * BatchGeoGoogleMapsMarker.MarkerGroups.groupsArray
 */
(function () {
  var MarkerGroups = function () {
    var self = this;
    var isThematicNumeric = false;
    var isThematic = false;
    var isReverseOrder = false;
    var numericCount = 0; // keep track of number of numeric values
    var dateCount = 0; // keep track of number of date values
    var zipCount = 0; // keep track of zip vlaues
    var timeCount = 0; // keep track of time values
    var markerColors =
      window.per.isThematic &&
      !window.per.disablethematic_cb &&
      !window.per.isCurrentThematicMarkerGroupDate
        ? window.per.thematicColors
        : window.per.colors;
    var arrayOfGroups = [];
    var colorIndiciesInUse = [];
    var colorObjectsInUse = [];
    var heatColorObjectsInUse = [];
    var heatFilterGroups = [];
    var filterGroups = [];
    var filterGroupObjects = [];
    self.startValue = 0;
    self.stopValue = 9;
    self.markerScaler = 9;
    self.limit = 0;
    const DISTANCE_COLUMN_NAME = "Distance Between Points";

    /* private variable, sorted array of groups in order of occurance
			arrayOfGroups[0] = {
			name : "Example Group 2",
			count: 4, <--- number of markers in this group
			all: [....] <--- array of pointers to all markers in this group
			}
		*/
    var gOc = {}; /* private variable, associative array of groups, looks like:
			gOc["Example Group 1"] : <number of markers>
			gOc["Example Group 2"] : <number of markers>
		*/
    var groupsArray = []; /* group array, this is where legend is it looks like
			gA[0] = {
			name : "Example Group 1",
			clr : "red",
			all: [....] <--- array of pointers to all markers in this group
			}
			gA[1] = {
			name : "Example Group 2",
			clr : "blue",
			all: [....] <--- array of pointers to all markers in this group
			}
			...
			*/
    var initVariables = function () {
      isThematicNumeric = false;
      isThematic = false;
      isReverseOrder = false;
      numericCount = 0; // keep track of number of numeric values
      dateCount = 0; // keep track of number of date values
      zipCount = 0; // keep track of zip vlaues
      timeCount = 0; // keep track of time values
      (markerColors =
        window.per.isThematic &&
        !window.per.disablethematic_cb &&
        !window.per.isCurrentThematicMarkerGroupDate
          ? window.per.thematicColors
          : window.per.colors),
        (arrayOfGroups = []);
      gOc = [];
      groupsArray = [];
      colorIndiciesInUse = [];
      colorObjectsInUse = [];
      heatColorObjectsInUse = [];
    };

    var buildMarkerGroups = function () {
      BatchGeo.timer("start buildGroups()");
      initVariables();

      let markersData = self.options.markersData;
      let markerShortcut = markersData.mapRS; // shortcut;

      const buildSingleGroup = () => {
        for (let i = 0; i < markerShortcut.length; i++) {
          markerShortcut[i].clr = markerColors[0];
        }
        groupsArray[0] = { name: "Marker", clr: markerColors[0] };

        return groupsArray;
      };

      if (window.per.group_col === -1) {
        return buildSingleGroup();
      }

      // loop through all markers to count type occurances (numeric, date, zip) and group by values
      self.MarkerGroups._groupOccurancesByValue(markerShortcut, markersData);
      if (arrayOfGroups.length == 1) {
        return buildSingleGroup();
      }

      let distanceMode = false;
      if (
        window.per.columnNames[window.per.group_col] == DISTANCE_COLUMN_NAME
      ) {
        // distance mode activated
        distanceMode = true;
      }

      if (markersData.disablethematic_cb) $("#disablethematic").show(); // turn this on here because it will get turned off below if things aren't thematic anyway
      if (
        (!markersData.disablethematic_cb /* thematic mode not manually disabled */ &&
          (arrayOfGroups.length > 6 ||
            (arrayOfGroups.length == 6 &&
              distanceMode)) /* only activate thematic mode if more than 6 groups */ &&
          markerShortcut.length >
            20 /* only activate if more than 20 markers */ &&
          (numericCount / markerShortcut.length >
            0.9 /* only activate if more than 90% of groups are numeric */ ||
            dateCount / markerShortcut.length >
              0.9 /* OR if 90% of groups are date based */ ||
            timeCount / markerShortcut.length > 0.9)) ||
        // any time distance mode is considered and there are more than 5 groups
        // thematic mode should.
        (arrayOfGroups.length >= 6 && distanceMode)
      ) {
        // activate thematic mode
        isThematic = true;
        window.per.isThematic = true;
        $("#disablethematic").show();
        BatchGeo.timer("end buildGroups()");
        const isDate = numericCount < dateCount;
        window.per.isCurrentThematicMarkerGroupDate = isDate;
        return self.MarkerGroups._buildThematic(
          arrayOfGroups,
          isDate,
          zipCount / markerShortcut.length >= 0.9,
          timeCount / markerShortcut.length > 0.9,
          markersData,
          distanceMode,
        );
      } else {
        //deactivate thematic mode
        window.per.isThematic = false;
        window.per.isCurrentThematicMarkerGroupDate = false;
        isThematicNumeric = false;
        isThematic = false;
        markerColors = window.per.colors;
      }

      for (let i = 0; i < arrayOfGroups.length; i++) {
        gOc[arrayOfGroups[i].name] = i;
      }

      self.MarkerGroups._populateGroups();
      if (
        groupsArray.length == markerColors.length &&
        arrayOfGroups.length > groupsArray.length
      ) {
        if (markersData.locale != "jp") {
          groupsArray[groupsArray.length - 1] = {
            name: "Others",
            clr: markerColors[groupsArray.length - 1],
            all: groupsArray[groupsArray.length - 1].all,
          };
        } else {
          groupsArray[groupsArray.length - 1] = {
            name: "その他",
            clr: markerColors[groupsArray.length - 1],
            all: groupsArray[groupsArray.length - 1].all,
          };
        }
      }

      BatchGeo.timer("end buildGroups()");
      return groupsArray;
    };

    var _groupOccurancesByValue = function (markerShortcut, markersData) {
      BatchGeo.timer("start groupOccurancesByValue()");
      arrayOfGroups = [];
      for (var i = 0; i < markerShortcut.length; i++) {
        var rowMarker = markerShortcut[i];
        //set this row's group name to rowMarker.distance
        rowMarker.g = self.MarkerGroups._getMarkerDistance(
          rowMarker,
          markersData,
        );
        if (BatchGeo.isNumber(rowMarker.g) || rowMarker.g == " ") {
          // if group is numeric, increment numeric counter
          numericCount++;
          if (!isNaN(rowMarker.g) && rowMarker.g.length == 5) zipCount++; // group is 5 digits so we will assume its a zip code
        } else {
          if (BatchGeo.isDate(rowMarker.g))
            dateCount++; // group is a date
          else if (BatchGeo.isTime(rowMarker.g)) timeCount++; // group is a time
        }

        // foundGroup is a variable that will track if we found the group string in the arrayOfGroups variable which means we don't need to create a new group
        var foundGroup = false;
        // iterate through array of groups
        for (var c = 0; c < arrayOfGroups.length; c++) {
          // check group name equals the current markers group
          if (arrayOfGroups[c].name == rowMarker.g) {
            // the only weird thing we are doing here is concating group name with a string which causes JS to convert it to a string so we can use indexOf which is a simple string comparison function
            if (
              (arrayOfGroups[c].name + "").toLowerCase().indexOf("other") == -1
            ) {
              // we matched an existing group, so increment one
              arrayOfGroups[c].count++;
              // add index of map row to arrayOfGroups, now we have a pointer back to the index of the marker that we can use for filtering
              arrayOfGroups[c].all[arrayOfGroups[c].all.length] = i;
            }
            foundGroup = true; // set found to true
          }
        }

        // create new group because we didn't find the value in existing groups
        if (!foundGroup) {
          arrayOfGroups[arrayOfGroups.length] = {
            name: rowMarker.g, // group name / string (this is what shows up in legend)
            count: 1, // number of markers in this group, start at 1
            all: [i], // array pointing to all markers in this group
          };
        }
      }
      BatchGeo.timer("end groupOccurancesByValue()");
    };

    var resetValues = function () {
      self.limit = 0;
      self.startValue = 0;
      self.stopValue = 9;
    };

    var _populateGroups = function () {
      BatchGeo.timer("start populateGroups()");

      var markerShortcut = self.options.markersData.mapRS;
      groupsArray = [];
      var gOclen = Object.keys(gOc).length; // do this once up here because its expensive
      self.limit = gOclen;
      let distanceMode = false;
      let metric = null;

      if (window.batchGeoGoogleMapsMarker !== undefined) {
        metric = window.batchGeoGoogleMapsMarker.MarkerLegend.getMetricValue();
      }

      if (
        window.per.columnNames[window.per.group_col] == DISTANCE_COLUMN_NAME
      ) {
        distanceMode = true;
      }
      if (distanceMode) {
        for (let q = 0; q < markerShortcut.length; q++) {
          var u = 0;
          var isSet = false;
          if (gOc[markerShortcut[q].g] >= 0 || gOclen == 0) {
            for (; u < groupsArray.length; u++)
              if (groupsArray[u] && groupsArray[u].name == markerShortcut[q].g)
                break;
            if (u < 5) {
              // found existing spot
            } else {
              // find first free spot
              for (u = 0; u < groupsArray.length; u++) {
                if (!groupsArray[u]) break;
              }
            }

            if (
              self.MarkerGroups.heatFilterGroups.includes(markerShortcut[q].g)
            ) {
              var color =
                self.MarkerGroups.heatColorObjectsInUse[
                  self.MarkerGroups.heatFilterGroups.indexOf(
                    markerShortcut[q].g,
                  )
                ].location;
              markerShortcut[q].clr = self.options.heatColors[color];
              groupsArray[u] = groupsArray[u] || {
                name: markerShortcut[q].g,
                clr: self.options.heatColors[color],
                all: {},
              };
              groupsArray[u].all[q] = 1; // add pointer to marker index to group info

              for (
                let r = 0;
                r < self.MarkerGroups.heatFilterGroups.length;
                r++
              ) {
                if (
                  self.MarkerGroups.heatFilterGroups[r] == markerShortcut[r].g
                ) {
                  markerShortcut[r].clr =
                    self.options.heatColors[
                      self.MarkerGroups.heatColorObjectsInUse[r].location
                    ];
                  isSet = true;
                }
              }
            }
          }
          if (!isSet) {
            markerShortcut[q].clr = self.options.heatColors[u];
            groupsArray[u] = groupsArray[u] || {
              name: markerShortcut[q].g,
              clr: self.options.heatColors[u],
              all: {},
            };
            groupsArray[u].all[q] = 1; // add pointer to marker index to group info
          }
        } //end forloop markerShortcut.length
        groupsArray.sort(function (a, b) {
          return BatchGeo.val(a.name) - BatchGeo.val(b.name);
        }); // reverse sort order
        isReverseOrder = true;

        //move empty array to the end
        let groupItemIndex = groupsArray.findIndex(
          (group) => group.name == " ",
        );
        let groupItem;
        if (groupItemIndex >= 0) {
          //remove from current location in array
          groupItem = groupsArray.splice(groupItemIndex, 1)[0]; //splice returns an arary
          if (groupItem) {
            groupsArray.push(groupItem);
          }
        }
        const hasUnselectedMarkers = groupsArray.some(
          (group) => group.name === " ",
        );

        const offset = hasUnselectedMarkers ? 1 : 0; // this accounts for the offchance that the last group is not unselected
        for (let n = 0; n < groupsArray.length; n++) {
          if (
            groupsArray[n].name.trim().length !== 0 &&
            !isNaN(Number(groupsArray[n].name))
          )
            groupsArray[n].name = groupsArray[n].name + " " + metric;
          let markers = Object.keys(groupsArray[n].all);
          if (n < groupsArray.length - offset) {
            // set color
            groupsArray[n].clr = self.options.heatColors[n];
            // update markers
            for (let m = 0; m < markers.length; m++) {
              markerShortcut[markers[m]].clr = self.options.heatColors[n];
              markerShortcut[markers[m]].heatClr = self.options.heatColors[n];
            }
          } else {
            if (hasUnselectedMarkers) {
              // set color
              groupsArray[n].clr = "grey";

              // update markers
              for (let m = 0; m < markers.length; m++) {
                markerShortcut[markers[m]].clr = "grey";
              }
            }
          }
        }
      } else {
        for (let i = 0; i < markerShortcut.length; i++) {
          let u = 0;
          let isSet = false;
          if (
            (gOc[markerShortcut[i].g] >= self.startValue &&
              gOc[markerShortcut[i].g] < self.stopValue) ||
            gOclen === 0
          ) {
            for (; u < groupsArray.length; u++) {
              if (
                groupsArray[u] &&
                groupsArray[u].name === markerShortcut[i].g
              ) {
                break;
              }
            }
            if (u < markerColors.length - 1) {
              // found existing spot
            } else {
              // find first free spot
              for (u = 0; u < groupsArray.length; u++) {
                if (!groupsArray[u]) break;
              }
            }
            var filterGroupsSansSearch =
              self.MarkerGroups.colorObjectsInUse.filter(
                (color) => color.location >= 0,
              );
            if (filterGroupsSansSearch.includes(markerShortcut[i].g)) {
              let color =
                self.MarkerGroups.colorObjectsInUse[
                  filterGroupsSansSearch.indexOf(markerShortcut[i].g)
                ].location;
              markerShortcut[i].clr = markerColors[color];

              groupsArray[u] = groupsArray[u] || {
                name: markerShortcut[i].g,
                clr: markerColors[color],
                all: {},
              };
              groupsArray[u].all[i] = 1; // add pointer to marker index to group info

              for (let q = 0; q < filterGroupsSansSearch.length; q++) {
                if (filterGroupsSansSearch[q] == markerShortcut[i].g) {
                  markerShortcut[i].clr =
                    markerColors[
                      self.MarkerGroups.colorObjectsInUse[q].location
                    ];
                  isSet = true;
                }
              }
            }
          } else if (
            gOclen == 10 &&
            gOc[markerShortcut[i].g] == self.stopValue
          ) {
            // handles the edge case for 10 columns
            u = markerColors.length - 1;
            if (self.MarkerGroups.filterGroups.includes(markerShortcut[i].g)) {
              let color =
                self.MarkerGroups.colorObjectsInUse[
                  self.MarkerGroups.filterGroups.indexOf(markerShortcut[i].g)
                ].location;
              markerShortcut[i].clr = markerColors[color];
              groupsArray[u] = groupsArray[u] || {
                name: markerShortcut[i].g,
                clr: markerColors[color],
                all: {},
              };
              groupsArray[u].all[i] = 1; // add pointer to marker index to group info

              for (let q = 0; q < self.MarkerGroups.filterGroups.length; q++) {
                if (self.MarkerGroups.filterGroups[q] == markerShortcut[i].g) {
                  markerShortcut[i].clr =
                    markerColors[
                      self.MarkerGroups.colorObjectsInUse[q].location
                    ];
                  isSet = true;
                }
              }
            }
          } else {
            // this group did not make top 6
            // others group
            // when looking at the next set we are going to naturally fall back into the others group
            // before placing into the others group, check to make sure that we are not actually in the
            // list of things that should remain...

            u = markerColors.length - 1;
            if (self.MarkerGroups.filterGroups.length > 0) {
              for (let q = 0; q < self.MarkerGroups.filterGroups.length; q++) {
                if (self.MarkerGroups.filterGroups[q] == markerShortcut[i].g) {
                  markerShortcut[i].clr =
                    markerColors[
                      self.MarkerGroups.colorObjectsInUse[q].location
                    ]; //que
                  isSet = true;
                }
              }
            }
          }
          if (!isSet) {
            markerShortcut[i].clr = markerColors[u];
            groupsArray[u] = groupsArray[u] || {
              name: markerShortcut[i].g,
              clr: markerColors[u],
              all: {},
            };
            groupsArray[u].all[i] = 1; // add pointer to marker index to group info
          }
        }
      }
      BatchGeo.timer("end populateGroups()");
    };

    /**
     * Adjusts a numeric string by 1, 0.1, or 0.01 based on specified conditions.
     *
     * @param {string} targetVal - The input numeric string to be adjusted.
     * @param {boolean} adjustCondition - Indicates whether adjustment should be applied.
     * @param {number} breakpointValue - The value that replaces targetVal.
     * @param {number} firstAfterTargetVal - The first value in the range.
     * @param {RegExp} numericAndMinusCommaFilter - Regular expression to filter non-numeric characters.
     * @returns {string} The adjusted numeric string.
     */
    var composeOtherGroupName = function (
      targetVal,
      adjustCondition,
      breakpointValue,
      firstAfterTargetVal,
      numericAndMinusCommaFilter,
      isReverseOrder = false,
    ) {
      let finalAdjuster = 0;
      let startingDecimalSpaceCount =
        breakpointValue.toString().split(".")[1]?.length || 0;
      let adjustedDecimalSpaceCount = 0;
      const numberOnlyStr = targetVal.replace(numericAndMinusCommaFilter, "");
      if (adjustCondition) {
        const options = [1, 0.1, 0.01];
        const tempAdjuster = options.find((num, index) => {
          const adjustedNum = (breakpointValue + num).toFixed(index);
          const orderSpecificCondition = isReverseOrder
            ? parseFloat(numberOnlyStr) >= adjustedNum
            : parseFloat(numberOnlyStr) <= adjustedNum;
          if (adjustedNum <= firstAfterTargetVal && orderSpecificCondition) {
            adjustedDecimalSpaceCount = index;
            return true;
          }
          return false;
        });
        if (tempAdjuster) {
          finalAdjuster = tempAdjuster;
        }
      }

      const finalDecimalSpaceCount = Math.max(
        startingDecimalSpaceCount,
        adjustedDecimalSpaceCount,
      );
      const adjustedBreakpointValue = (breakpointValue + finalAdjuster).toFixed(
        finalDecimalSpaceCount,
      );
      return targetVal.replace(numberOnlyStr, adjustedBreakpointValue);
    };

    var isSingleValueRange = function (
      nextValue,
      startOfNextRange,
      startValue,
      groupName,
    ) {
      if (nextValue === undefined) {
        // no next value = single value range
        return true;
      } else if (nextValue >= startOfNextRange && startValue === groupName) {
        // next value is in next range and current value matches the existing groupName = single value range
        return true;
      }
      return false;
    };

    var handleUndefinedGroups = function () {
      // find any delete indexes
      let spliceIndexes = [];
      groupsArray.forEach((item, index) => {
        if (!item) {
          spliceIndexes.push(index);
        }
      });

      // sort array high to low so we can splice without selecting the incorrect item
      spliceIndexes.sort((a, b) => b - a);

      spliceIndexes.forEach((index) => {
        groupsArray.splice(index, 1);
      });
    };

    /**
     * Takes a group name and formats it for the legend. It formats it in
     * the following ways:
     *
     * 1. If it's a negative, like -10 for example, it will convert it to
     * use accounting format with parenthesis around it like (10)
     *
     * 2. It will convert the numbers to a more readable, smaller, format.
     * For example, 10000000 will become 10M.
     *
     * @param {string|number} name The group name to format
     * @return {string} Returns a formatted string to represent a number
     */
    function formatGroupName(name, x) {
      // Try converting the name to a number
      var value = BatchGeo.val(name);

      var metric = null;
      let distanceMode = false;
      if (
        window.per.columnNames[window.per.group_col] == DISTANCE_COLUMN_NAME
      ) {
        distanceMode = true;
      }
      if (window.batchGeoGoogleMapsMarker !== undefined) {
        metric = window.batchGeoGoogleMapsMarker.MarkerLegend.getMetricValue();
      }

      var isDollarAmount = false; // used to dif between dollar and distance metrics 'K'

      // If it's negative wrap in parenthesis and remove the negative
      // symbol by forcing into a positive

      var formattedValue =
        value < 0
          ? "(" + BatchGeo.tinyNum(Math.abs(value), x) + ")"
          : BatchGeo.tinyNum(value, x);

      // If the original name contained a $ add it back
      if (BatchGeo.isDollarAmount(name)) {
        formattedValue = "$" + formattedValue;
        isDollarAmount = true;
      }
      // Or if the original name had a % add it back
      else if (BatchGeo.isPercentage(name)) {
        formattedValue = formattedValue + "%";
      }

      if (
        distanceMode &&
        metric !== null &&
        ["mi", "ft", "km", "k"].indexOf(metric) !== -1 &&
        !isDollarAmount
      ) {
        // is distance metric
        formattedValue = formattedValue + " " + metric;
      }
      // Force to a string type for consistency
      return formattedValue.toString();
    }

    var _buildThematic = function (
      gAc,
      isDate,
      isZip,
      isTime,
      markersData,
      distanceMode,
    ) {
      BatchGeo.timer("start buildThematic()");
      // define private function to build thematic values
      // actually doesn't really need to be a function since it only gets called once
      let thematicColor;

      /**
       * globally matches and removes characters that are not digits, minus signs, decimal points, or commas
       */
      const numericAndMinusCommaFilter = /[^0-9.,-]+/g;

      /**
       * globally matches and removes characters that are not digits, minus signs, or decimal points
       */
      const numericAndMinusFilter = /[^0-9.-]+/g;

      // uses _.merge() with an empty array to clone the original array so
      // changes to it won't be global
      if (isDate) {
        thematicColor = _.merge([], window.per.colors);
      } else {
        thematicColor = _.merge([], window.per.thematicColors);
      }

      if (
        markersData.columnNames[markersData.group_col] &&
        [DISTANCE_COLUMN_NAME.toLowerCase()].indexOf(
          markersData.columnNames[markersData.group_col].toLowerCase(),
        ) >= 0
      ) {
        thematicColor = self.options.heatColors;
        distanceMode = true;
      } else {
        // We want to build a number of groups equivelant to the length of self.options.thematicColors array.
        // If we're handling a date, we want to use the colors from window.per.colors.
        // The window.per.colors array is larger than the window.per.thematicColors array.
        // Set the length of thematicColor explicitly to guarantee we build the expected number of groups.
        thematicColor = isDate
          ? _.merge([], window.per.colors)
          : _.merge([], window.per.thematicColors);
        thematicColor.length = self.options.thematicColors.length;
      }

      // if group field selection is blank, then we are here because
      // its a distance thematic map, or if group name matches list,
      // reverse sort order so low numbers are first
      if (
        markersData.group_col < 0 ||
        (markersData.columnNames[markersData.group_col] &&
          [
            "rank",
            "position",
            DISTANCE_COLUMN_NAME.toLowerCase(),
            "row",
          ].indexOf(
            markersData.columnNames[markersData.group_col].toLowerCase(),
          ) >= 0)
      ) {
        isReverseOrder = true;
      }
      if (isDate || isTime) {
        isReverseOrder = true;
      }

      gAc.sort(function (a, b) {
        if (isDate) {
          // sort by dates
          return Date.parse(a.name) - Date.parse(b.name);
        } else if (isTime) {
          // sort by times
          return BatchGeo.parseTime(a.name) - BatchGeo.parseTime(b.name);
        } else {
          // sort by highest numbers first
          if (isNaN(BatchGeo.val(a.name))) {
            return 1;
          }
          if (isNaN(BatchGeo.val(b.name))) {
            return -1;
          }
          if (isReverseOrder) {
            return BatchGeo.val(a.name) - BatchGeo.val(b.name);
          }
          return BatchGeo.val(b.name) - BatchGeo.val(a.name);
        }
      });

      let breakpoints;
      let groupData = undefined;

      if (!window.per.group_data) {
        window.per.group_data = [];
      } else {
        groupData = window.per.group_data.find(
          (x) =>
            x.group_col === window.per.group_col ||
            x.group_col === parseInt(window.per.group_col),
        );
      }

      if (groupData) {
        breakpoints = groupData.breakpoints;
      } else {
        let values = [];
        gAc.forEach((x) => {
          for (let i = 0; i < x.count; i++) {
            const value = x.name;
            if (isDate) {
              let parsed = Date.parse(value);
              if (!isNaN(parsed)) values.push(parsed);
            } else if (isTime) {
              const parsed = BatchGeo.parseTime(value);
              if (!isNaN(parsed)) values.push(Date.parse(parsed));
            } else {
              const parsed =
                typeof value === "string"
                  ? parseFloat(value.replace(numericAndMinusFilter, ""))
                  : value;
              if (!isNaN(parsed)) values.push(parsed);
            }
          }
        });

        if (isReverseOrder) {
          values.sort((a, b) => b - a); //we still group based on high-to-low
        }

        // ! Used here to determine the number of breakpoints we should have.
        let newBreakpoints = BatchGeo.getBreakpoints(
          values,
          thematicColor.length,
        );
        if (!isDate && !isTime) {
          newBreakpoints = BatchGeo.roundBreakpoints(newBreakpoints);
        }

        if (isReverseOrder) {
          newBreakpoints.sort((a, b) => a - b); //return breakpoints in the desired sort order.
        }

        breakpoints = newBreakpoints;

        window.per.group_data.push({
          group_col: parseInt(window.per.group_col),
          breakpoints: newBreakpoints,
        });
      }

      // ! Can inform the groupLimit for building ranges
      let groupLimit =
        breakpoints.length <= thematicColor.length
          ? breakpoints.length - 1
          : thematicColor.length;
      const hasEmptyGroup = gAc.some((item) => item.name === " ");
      let colorOffset = 0;
      for (let u = 0; u < groupLimit; u++) {
        let iStart =
          u === 0
            ? u
            : gAc.indexOf(
                gAc.find((x) => {
                  let parsedName = x.name;
                  if (isDate) {
                    parsedName = Date.parse(parsedName);
                  } else if (isTime) {
                    parsedName = BatchGeo.parseTime(parsedName);
                  } else if (typeof x.name === "string") {
                    parsedName = parseFloat(
                      parsedName.replace(numericAndMinusFilter, ""),
                    );
                  }
                  return !isNaN(parsedName) && isReverseOrder
                    ? parsedName > breakpoints[u]
                    : parsedName <= breakpoints[u];
                }),
              );
        if (iStart < 0) continue;

        let iEnd =
          u === groupLimit - 1
            ? gAc.length - 1
            : gAc.indexOf(
                gAc.find((x) => {
                  let parsedName = x.name;
                  if (isDate) {
                    parsedName = Date.parse(parsedName);
                  } else if (isTime) {
                    parsedName = BatchGeo.parseTime(parsedName);
                  } else if (typeof x.name === "string") {
                    parsedName = parseFloat(
                      parsedName.replace(numericAndMinusFilter, ""),
                    );
                  }
                  return !isNaN(parsedName) && isReverseOrder
                    ? parsedName > breakpoints[u + 1]
                    : parsedName <= breakpoints[u + 1];
                }),
              );

        if (iEnd < 0) iEnd = gAc.length - 1;

        const startVal = gAc[iStart].name;
        const endVal = gAc[iEnd].name;
        let groupName1 = "";
        let groupName2 = "";

        if (isDate || isTime) {
          groupName1 = startVal;
          groupName2 = endVal;
        } else {
          if (isReverseOrder) {
            const endNumberOnlyStr = endVal.replace(
              numericAndMinusCommaFilter,
              "",
            );
            groupName2 = endVal.replace(
              endNumberOnlyStr,
              breakpoints[Math.min(breakpoints.length - 1, u + 1)],
            );
            const nextValue = gAc[iStart + 1]?.name?.replace(
              numericAndMinusFilter,
              "",
            );
            if (
              isSingleValueRange(
                nextValue,
                endNumberOnlyStr,
                startVal,
                groupName2,
              )
            ) {
              // if groupname1 === groupname2 the range gets collapsed later where groupsArray[u].name is set
              groupName1 = groupName2;
            } else {
              groupName1 = composeOtherGroupName(
                startVal,
                u !== 0,
                breakpoints[u],
                parseFloat(nextValue),
                numericAndMinusCommaFilter,
                isReverseOrder,
              );
            }
          } else {
            const startNumberOnlyStr = startVal.replace(
              numericAndMinusCommaFilter,
              "",
            );
            groupName1 = startVal.replace(startNumberOnlyStr, breakpoints[u]);
            groupName2 = composeOtherGroupName(
              endVal,
              u !== groupLimit - 1,
              breakpoints[u + 1],
              parseFloat(
                gAc[iEnd === 0 ? iEnd : iEnd - 1].name.replace(
                  numericAndMinusFilter,
                  "",
                ),
              ),
              numericAndMinusCommaFilter,
              isReverseOrder,
            );
          }
        }

        let roundTo = 1;
        if (groupName1 !== groupName2) {
          let groupRangeStart =
            typeof groupName1 === "string"
              ? parseFloat(groupName1.replace(numericAndMinusFilter, ""))
              : groupName1;
          let groupRangeEnd =
            typeof groupName2 === "string"
              ? parseFloat(groupName2.replace(numericAndMinusFilter, ""))
              : groupName2;
          if (
            groupRangeStart > 9999 &&
            groupRangeEnd > 9999 &&
            groupRangeStart !== groupRangeEnd
          ) {
            let x = BatchGeo.getSignificantRoundingValue(
              groupRangeStart,
              groupRangeEnd,
            );
            if (x > roundTo) roundTo = x;
          }
        }
        groupsArray[u] = {
          clr: thematicColor[u - colorOffset],
        };

        if (isZip) {
          // if its a zip code, then create ranges that look like 97213-97215
          groupsArray[u].name =
            groupName1 +
            ((groupName2 + "").trim() !== "" ? " - " + groupName2 : "");
        } else if (isDate || isTime) {
          // date or time based ranges, don't do any special formatting
          groupsArray[u].name =
            groupName1 + (groupName1 == groupName2 ? "" : " - " + groupName2);
        } else {
          // if it's not a date and its numeric, ranges look like 500-200,
          // dlr is used for dollar formatting, tinyNum converts 1000's to
          // 1k's)
          groupsArray[u].name =
            formatGroupName(groupName1, roundTo) +
            (formatGroupName(groupName1, roundTo) ==
            formatGroupName(groupName2, roundTo)
              ? ""
              : " - " + formatGroupName(groupName2, roundTo));
        }

        groupsArray[u].all = {}; // init marker array

        if (distanceMode && iStart === 0 && hasEmptyGroup) {
          // empty group should have been sorted into the 0th index
          // account for (unselected markers) in distance mode if they exist
          if (gAc && gAc[0] && gAc[0].name === " ") {
            iStart += 1;
          }
        }
        let end = u === groupLimit - 1 ? iEnd + 1 : iEnd; // + 1 allows for the end boundary values to be included.
        for (let r = iStart; r < end; r++) {
          // populate mapRS with correct colors
          for (let c = 0; c < gAc[r].all.length; c++) {
            markersData.mapRS[gAc[r].all[c]].clr = groupsArray[u].clr;
            markersData.mapRS[gAc[r].all[c]].heatClr = groupsArray[u].clr;
            // add pointedatatr to marker index to group info
            groupsArray[u].all[gAc[r].all[c]] = 1;
          }
        }

        // If we have a group that doesn't contain any data set to undefined
        // and increment the colorOffset so we don't skip any thematic colors.
        // The undefined groups will be removed/handled once we're done looping.
        if (!Object.keys(groupsArray[u].all).length) {
          groupsArray[u] = undefined;
          colorOffset++;
        }
      }

      handleUndefinedGroups();

      if (distanceMode && hasEmptyGroup) {
        groupsArray.push({
          clr: "grey",
          name: "(Unselected Markers)",
          all: {},
        });
        for (let c = 0; c < gAc[0].all.length; c++) {
          markersData.mapRS[gAc[0].all[c]].clr = "grey";
          // add pointedatatr to marker index to group info
          groupsArray[groupsArray.length - 1].all[gAc[0].all[c]] = 1;
          groupsArray[groupsArray.length - 1].clr = "grey";
        }
      }

      isThematicNumeric = !isDate && !isZip;
      BatchGeo.timer("end buildThematic()");
    };

    var _getMarkerDistance = function (rowMarker, markersData) {
      // begin distance grouping
      /*if distance exists and lat/long exists and if map length more than 25, and no group column set */
      if (
        rowMarker.distance &&
        rowMarker.lt &&
        markersData.mapRS.length > 25 &&
        (markersData.group_col < 0 ||
          (markersData.columnNames[markersData.group_col] &&
            markersData.columnNames[markersData.group_col].toLowerCase() ===
              "distance"))
      ) {
        /* if above line is true then check distance is numeric */
        if (isNaN(rowMarker.distance)) {
          /* if distance is not a number, then default to .01 because this will only be true for first address which we are calculating distance from */
          return 0.01;
        } else {
          /* if distance is a number then return it */
          return rowMarker.distance;
        }
      } else {
        /* just defaulting out of distance calculation, either blank out group if it doesn't exist or return group value if it does */
        if (BatchGeo.ifstr(rowMarker.g).length === 0) {
          return " ";
        } else {
          return rowMarker.g;
        }
      }
      // end distance grouping
    };

    var getGroupsArray = function () {
      return groupsArray;
    };

    // Public API
    self.MarkerGroups = {
      formatGroupName: formatGroupName,
      buildGroups: buildMarkerGroups,
      isThematicNumeric: isThematicNumeric,
      isThematic: isThematic,
      isReverseOrder: isReverseOrder,
      colorIndiciesInUse: colorIndiciesInUse,
      colorObjectsInUse: colorObjectsInUse,
      heatColorObjectsInUse: heatColorObjectsInUse,
      heatFilterGroups: heatFilterGroups,
      filterGroups: filterGroups,
      filterGroupObjects: filterGroupObjects,
      getGroupsArray: getGroupsArray,
      resetValues: resetValues,
      composeOtherGroupName: composeOtherGroupName,
      _groupOccurancesByValue: _groupOccurancesByValue,
      _buildThematic: _buildThematic,
      _populateGroups: _populateGroups,
      _getMarkerDistance: _getMarkerDistance,
    };
  };

  window.MarkerGroups = MarkerGroups;
})(window);
